// App.jsx
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AllTransactions from "./pages/AllTransactions";
import ProtectedRoute from "./components/ProtectedRoute";
import AccountCodes from "./pages/AccountCodes";
import UserManagement from "./pages/UserManagement";
import StorageItems from "./pages/StorageItems";
import StorageTransactions from "./pages/StorageTransactions";
import JournalReports from "./pages/JournalReports";
import LedgerReports from "./pages/LedgerReports";
import IncomeStatements from "./pages/IncomeStatement";
import VillaManagement from "./pages/VillaManagement";
import MyProfile from "./pages/MyProfile";
import ImportJournal from "./pages/ImportJournal";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user_management"
          element={
            <ProtectedRoute>
              <UserManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transactions"
          element={
            <ProtectedRoute>
              <AllTransactions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account_codes"
          element={
            <ProtectedRoute>
              <AccountCodes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/storage_items"
          element={
            <ProtectedRoute>
              <StorageItems />
            </ProtectedRoute>
          }
        />
        <Route
          path="/storage_transactions"
          element={
            <ProtectedRoute>
              <StorageTransactions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/journal_reports"
          element={
            <ProtectedRoute>
              <JournalReports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ledger_reports"
          element={
            <ProtectedRoute>
              <LedgerReports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/income_statements"
          element={
            <ProtectedRoute>
              <IncomeStatements />
            </ProtectedRoute>
          }
        />
        <Route
          path="/villas"
          element={
            <ProtectedRoute>
              <VillaManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my_profile"
          element={
            <ProtectedRoute>
              <MyProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/import_journal"
          element={
            <ProtectedRoute>
              <ImportJournal />
            </ProtectedRoute>
          }
        />
        <Route 
          path="*" 
          element={
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', textAlign: 'center' }}>
              <h1>404 - Page Not Found</h1>
              <p>The page you're looking for doesn't exist.</p>
            </div>
          } 
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
